import { Users, GraduationCap, BookOpen, Library, FileText, TrendingUp } from "lucide-react"
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from "recharts"
import { useAnalytics } from "../../../contexts/AnalyticsContext"

function AnalyticsPage() {
    let {analytics: stats, loading} = useAnalytics()

  // Chart data for students and preppers comparison
  const chartData = [
    {
      name: "Students",
      total: stats.total_students,
    },
    {
      name: "Preppers",
      total: stats.total_preppers,
    },
    {
      name: "Lecturers",
      total: stats.total_lecturers,
    },
  ]

  // Stats cards configuration
  const statCards = [
    {
      title: "Total Students",
      value: stats.total_students,
      description: "Active students on the platform",
      icon: Users,
      color: "text-primary",
    },
    {
      title: "Total Preppers",
      value: stats.total_preppers,
      description: "Registered preppers",
      icon: GraduationCap,
      color: "text-secondary",
    },
    {
      title: "Total Lecturers",
      value: stats.total_lecturers,
      description: "Active lecturers",
      icon: BookOpen,
      color: "text-accent",
    },
    {
      title: "Total Courses",
      value: stats.total_courses,
      description: "Available courses",
      icon: Library,
      color: "text-info",
    },
    {
      title: "Total Topics",
      value: stats.total_topics,
      description: "Course topics",
      icon: FileText,
      color: "text-warning",
    },
  ]

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    )
  }

  return (
    <div className="mt-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-xl md:text-3xl font-oswald font-light">Analytics Dashboard</h1>
          <p className="text-base-content/70">Platform statistics and insights</p>
        </div>
        <TrendingUp className="h-8 w-8 text-primary" />
      </div>

      {/* Stats Grid */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {statCards.map((stat) => {
          const Icon = stat.icon
          return (
            <div key={stat.title} className="stats shadow">
              <div className="stat">
                <div className="flex items-center justify-between">
                  <h2 className="stat-title text-sm">{stat.title}</h2>
                  <Icon className={`h-5 w-5 ${stat.color}`} />
                </div>
                <p className="stat-value text-3xl mt-2">{stat.value}</p>
                <p className="stat-desc mt-1">{stat.description}</p>
              </div>
            </div>
          )
        })}
      </div>

      {/* Charts Section */}
      <div className="grid gap-4 md:grid-cols-2 mt-8">
        {/* Distribution Chart */}
        <div className="card bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">User Distribution</h2>
            <p className="text-base-content/70 text-sm">Comparison of students, preppers, and lecturers</p>
            <div className="h-[300px] mt-4">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData}>
                  <XAxis dataKey="name" stroke="currentColor" fontSize={12} tickLine={false} axisLine={false} />
                  <YAxis
                    stroke="currentColor"
                    fontSize={12}
                    tickLine={false}
                    axisLine={false}
                    tickFormatter={(value) => `${value}`}
                  />
                  <Tooltip/>
                  <Bar dataKey="total" fill="hsl(var(--p))" radius={[4, 4, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default AnalyticsPage;